import React from 'react';
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import MultiTreeSelect from 'shared/components/MultiTreeSelect';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

const RawMultiTreeSelect = props => (
  // ReduxForm gives empty strings to fields as the default
  // initial value, but MultiTreeSelect expects an array
  <MultiTreeSelect {...props} value={props.value || []} />
);

const RawMultiTreeSelectField = wrapFormComponentWithLabelAndError(RawMultiTreeSelect);
RawMultiTreeSelectField.displayName = 'RawMultiTreeSelectField';

const MultiTreeSelectField = connectFormComponentToReduxForm(RawMultiTreeSelectField);
MultiTreeSelectField.displayName = 'MultiTreeSelectField';
export default MultiTreeSelectField;

const MultiTreeSelectInput = connectFormComponentToReduxForm(
  wrapFormComponentWithError(RawMultiTreeSelect)
);
export { MultiTreeSelectInput };
